import { render } from "./LanguageTiptool.vue?vue&type=template&id=d2b97a46&scoped=true"
import script from "./LanguageTiptool.vue?vue&type=script&lang=js"
export * from "./LanguageTiptool.vue?vue&type=script&lang=js"

import "./LanguageTiptool.vue?vue&type=style&index=0&id=d2b97a46&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2b97a46"]])

export default __exports__